import { ApiConfiguration } from '../api';
import { AppConfig } from '../common';
import { environment } from 'environments/environment';

export function ApiConfigurationFactory(config : AppConfig) {
    let apiConfig = new ApiConfiguration();

    apiConfig.withCredentials = true;
    apiConfig.basePath = environment.urls.api;
    
    return apiConfig;
}